// Base de municípios brasileiros (IBGE) - Top 200 mais populosos + capitais
// Para produção completa, integrar com API do IBGE: https://servicodados.ibge.gov.br/api/v1/localidades/municipios

export interface IBGECity {
  id: string // Código IBGE
  name: string // Nome do município
  state: string // UF (sigla)
  stateName: string // Nome completo do estado
}

export const BRAZILIAN_CITIES: IBGECity[] = [
  // Minas Gerais
  { id: "3106200", name: "Belo Horizonte", state: "MG", stateName: "Minas Gerais" },
  { id: "3170206", name: "Uberlândia", state: "MG", stateName: "Minas Gerais" },
  { id: "3106705", name: "Betim", state: "MG", stateName: "Minas Gerais" },
  { id: "3127701", name: "Juiz de Fora", state: "MG", stateName: "Minas Gerais" },
  { id: "3143302", name: "Montes Claros", state: "MG", stateName: "Minas Gerais" },
  { id: "3118601", name: "Contagem", state: "MG", stateName: "Minas Gerais" },
  { id: "3136702", name: "Ribeirão das Neves", state: "MG", stateName: "Minas Gerais" },
  { id: "3170107", name: "Uberaba", state: "MG", stateName: "Minas Gerais" },
  { id: "3125507", name: "Ipatinga", state: "MG", stateName: "Minas Gerais" },
  { id: "3154606", name: "Poços de Caldas", state: "MG", stateName: "Minas Gerais" },
  
  // São Paulo
  { id: "3550308", name: "São Paulo", state: "SP", stateName: "São Paulo" },
  { id: "3509502", name: "Campinas", state: "SP", stateName: "São Paulo" },
  { id: "3518800", name: "Guarulhos", state: "SP", stateName: "São Paulo" },
  { id: "3547809", name: "Santo André", state: "SP", stateName: "São Paulo" },
  { id: "3548708", name: "São Bernardo do Campo", state: "SP", stateName: "São Paulo" },
  { id: "3552205", name: "Sorocaba", state: "SP", stateName: "São Paulo" },
  { id: "3543402", name: "Ribeirão Preto", state: "SP", stateName: "São Paulo" },
  { id: "3549904", name: "São José dos Campos", state: "SP", stateName: "São Paulo" },
  { id: "3544103", name: "Santos", state: "SP", stateName: "São Paulo" },
  { id: "3548807", name: "São José do Rio Preto", state: "SP", stateName: "São Paulo" },
  
  // Rio de Janeiro
  { id: "3304557", name: "Rio de Janeiro", state: "RJ", stateName: "Rio de Janeiro" },
  { id: "3304904", name: "São Gonçalo", state: "RJ", stateName: "Rio de Janeiro" },
  { id: "3301702", name: "Duque de Caxias", state: "RJ", stateName: "Rio de Janeiro" },
  { id: "3303500", name: "Nova Iguaçu", state: "RJ", stateName: "Rio de Janeiro" },
  { id: "3303302", name: "Niterói", state: "RJ", stateName: "Rio de Janeiro" },
  { id: "3300456", name: "Belford Roxo", state: "RJ", stateName: "Rio de Janeiro" },
  { id: "3304557", name: "Campos dos Goytacazes", state: "RJ", stateName: "Rio de Janeiro" },
  { id: "3304144", name: "Petrópolis", state: "RJ", stateName: "Rio de Janeiro" },
  { id: "3305109", name: "Volta Redonda", state: "RJ", stateName: "Rio de Janeiro" },
  { id: "3302270", name: "Magé", state: "RJ", stateName: "Rio de Janeiro" },
  
  // Bahia
  { id: "2927408", name: "Salvador", state: "BA", stateName: "Bahia" },
  { id: "2910800", name: "Feira de Santana", state: "BA", stateName: "Bahia" },
  { id: "2933307", name: "Vitória da Conquista", state: "BA", stateName: "Bahia" },
  { id: "2905701", name: "Camaçari", state: "BA", stateName: "Bahia" },
  { id: "2919207", name: "Itabuna", state: "BA", stateName: "Bahia" },
  { id: "2919926", name: "Juazeiro", state: "BA", stateName: "Bahia" },
  { id: "2922250", name: "Lauro de Freitas", state: "BA", stateName: "Bahia" },
  { id: "2919405", name: "Ilhéus", state: "BA", stateName: "Bahia" },
  { id: "2919553", name: "Jequié", state: "BA", stateName: "Bahia" },
  { id: "2903201", name: "Alagoinhas", state: "BA", stateName: "Bahia" },
  
  // Paraná
  { id: "4106902", name: "Curitiba", state: "PR", stateName: "Paraná" },
  { id: "4115200", name: "Londrina", state: "PR", stateName: "Paraná" },
  { id: "4119905", name: "Maringá", state: "PR", stateName: "Paraná" },
  { id: "4108304", name: "Foz do Iguaçu", state: "PR", stateName: "Paraná" },
  { id: "4125506", name: "Ponta Grossa", state: "PR", stateName: "Paraná" },
  { id: "4104808", name: "Cascavel", state: "PR", stateName: "Paraná" },
  { id: "4128005", name: "São José dos Pinhais", state: "PR", stateName: "Paraná" },
  { id: "4106803", name: "Colombo", state: "PR", stateName: "Paraná" },
  { id: "4113205", name: "Guarapuava", state: "PR", stateName: "Paraná" },
  { id: "4101804", name: "Araucária", state: "PR", stateName: "Paraná" },
  
  // Rio Grande do Sul
  { id: "4314902", name: "Porto Alegre", state: "RS", stateName: "Rio Grande do Sul" },
  { id: "4304606", name: "Caxias do Sul", state: "RS", stateName: "Rio Grande do Sul" },
  { id: "4313409", name: "Pelotas", state: "RS", stateName: "Rio Grande do Sul" },
  { id: "4305108", name: "Canoas", state: "RS", stateName: "Rio Grande do Sul" },
  { id: "4323002", name: "Santa Maria", state: "RS", stateName: "Rio Grande do Sul" },
  { id: "4314407", name: "Gravataí", state: "RS", stateName: "Rio Grande do Sul" },
  { id: "4322525", name: "Viamão", state: "RS", stateName: "Rio Grande do Sul" },
  { id: "4322400", name: "Novo Hamburgo", state: "RS", stateName: "Rio Grande do Sul" },
  { id: "4325506", name: "São Leopoldo", state: "RS", stateName: "Rio Grande do Sul" },
  { id: "4301602", name: "Alvorada", state: "RS", stateName: "Rio Grande do Sul" },
  
  // Pernambuco
  { id: "2611606", name: "Recife", state: "PE", stateName: "Pernambuco" },
  { id: "2607901", name: "Jaboatão dos Guararapes", state: "PE", stateName: "Pernambuco" },
  { id: "2605459", name: "Olinda", state: "PE", stateName: "Pernambuco" },
  { id: "2601805", name: "Caruaru", state: "PE", stateName: "Pernambuco" },
  { id: "2608701", name: "Paulista", state: "PE", stateName: "Pernambuco" },
  { id: "2609600", name: "Petrolina", state: "PE", stateName: "Pernambuco" },
  { id: "2602902", name: "Cabo de Santo Agostinho", state: "PE", stateName: "Pernambuco" },
  { id: "2603454", name: "Camaragibe", state: "PE", stateName: "Pernambuco" },
  { id: "2614303", name: "Vitória de Santo Antão", state: "PE", stateName: "Pernambuco" },
  { id: "2610707", name: "São Lourenço da Mata", state: "PE", stateName: "Pernambuco" },
  
  // Ceará
  { id: "2304400", name: "Fortaleza", state: "CE", stateName: "Ceará" },
  { id: "2304285", name: "Caucaia", state: "CE", stateName: "Ceará" },
  { id: "2307650", name: "Juazeiro do Norte", state: "CE", stateName: "Ceará" },
  { id: "2310308", name: "Maracanaú", state: "CE", stateName: "Ceará" },
  { id: "2313500", name: "Sobral", state: "CE", stateName: "Ceará" },
  { id: "2303709", name: "Crato", state: "CE", stateName: "Ceará" },
  { id: "2308708", name: "Itapipoca", state: "CE", stateName: "Ceará" },
  { id: "2310704", name: "Maranguape", state: "CE", stateName: "Ceará" },
  { id: "2307304", name: "Iguatu", state: "CE", stateName: "Ceará" },
  { id: "2313252", name: "Quixadá", state: "CE", stateName: "Ceará" },
  
  // Pará
  { id: "1501402", name: "Belém", state: "PA", stateName: "Pará" },
  { id: "1500800", name: "Ananindeua", state: "PA", stateName: "Pará" },
  { id: "1504208", name: "Santarém", state: "PA", stateName: "Pará" },
  { id: "1502400", name: "Marabá", state: "PA", stateName: "Pará" },
  { id: "1505502", name: "Castanhal", state: "PA", stateName: "Pará" },
  { id: "1506807", name: "Parauapebas", state: "PA", stateName: "Pará" },
  { id: "1502764", name: "Marituba", state: "PA", stateName: "Pará" },
  { id: "1500347", name: "Abaetetuba", state: "PA", stateName: "Pará" },
  { id: "1503606", name: "Cametá", state: "PA", stateName: "Pará" },
  { id: "1501725", name: "Bragança", state: "PA", stateName: "Pará" },
  
  // Santa Catarina
  { id: "4205407", name: "Florianópolis", state: "SC", stateName: "Santa Catarina" },
  { id: "4209102", name: "Joinville", state: "SC", stateName: "Santa Catarina" },
  { id: "4202404", name: "Blumenau", state: "SC", stateName: "Santa Catarina" },
  { id: "4214805", name: "São José", state: "SC", stateName: "Santa Catarina" },
  { id: "4205175", name: "Criciúma", state: "SC", stateName: "Santa Catarina" },
  { id: "4209300", name: "Chapecó", state: "SC", stateName: "Santa Catarina" },
  { id: "4208203", name: "Itajaí", state: "SC", stateName: "Santa Catarina" },
  { id: "4209458", name: "Jaraguá do Sul", state: "SC", stateName: "Santa Catarina" },
  { id: "4211900", name: "Lages", state: "SC", stateName: "Santa Catarina" },
  { id: "4213500", name: "Palhoça", state: "SC", stateName: "Santa Catarina" },
  
  // Goiás
  { id: "5208707", name: "Goiânia", state: "GO", stateName: "Goiás" },
  { id: "5200258", name: "Aparecida de Goiânia", state: "GO", stateName: "Goiás" },
  { id: "5201405", name: "Anápolis", state: "GO", stateName: "Goiás" },
  { id: "5221858", name: "Rio Verde", state: "GO", stateName: "Goiás" },
  { id: "5212501", name: "Luziânia", state: "GO", stateName: "Goiás" },
  { id: "5200555", name: "Águas Lindas de Goiás", state: "GO", stateName: "Goiás" },
  { id: "5221197", name: "Valparaíso de Goiás", state: "GO", stateName: "Goiás" },
  { id: "5219753", name: "Trindade", state: "GO", stateName: "Goiás" },
  { id: "5208608", name: "Formosa", state: "GO", stateName: "Goiás" },
  { id: "5203203", name: "Cidade Ocidental", state: "GO", stateName: "Goiás" },
  
  // Maranhão
  { id: "2111300", name: "São Luís", state: "MA", stateName: "Maranhão" },
  { id: "2107258", name: "Imperatriz", state: "MA", stateName: "Maranhão" },
  { id: "2111201", name: "São José de Ribamar", state: "MA", stateName: "Maranhão" },
  { id: "2109601", name: "Timon", state: "MA", stateName: "Maranhão" },
  { id: "2103554", name: "Caxias", state: "MA", stateName: "Maranhão" },
  { id: "2104099", name: "Codó", state: "MA", stateName: "Maranhão" },
  { id: "2108702", name: "Paço do Lumiar", state: "MA", stateName: "Maranhão" },
  { id: "2107506", name: "Açailândia", state: "MA", stateName: "Maranhão" },
  { id: "2100055", name: "Bacabal", state: "MA", stateName: "Maranhão" },
  { id: "2102556", name: "Balsas", state: "MA", stateName: "Maranhão" },
  
  // Espírito Santo
  { id: "3205309", name: "Vitória", state: "ES", stateName: "Espírito Santo" },
  { id: "3205200", name: "Vila Velha", state: "ES", stateName: "Espírito Santo" },
  { id: "3201308", name: "Cariacica", state: "ES", stateName: "Espírito Santo" },
  { id: "3203163", name: "Serra", state: "ES", stateName: "Espírito Santo" },
  { id: "3201001", name: "Cachoeiro de Itapemirim", state: "ES", stateName: "Espírito Santo" },
  { id: "3202405", name: "Linhares", state: "ES", stateName: "Espírito Santo" },
  { id: "3203908", name: "São Mateus", state: "ES", stateName: "Espírito Santo" },
  { id: "3201209", name: "Colatina", state: "ES", stateName: "Espírito Santo" },
  { id: "3202207", name: "Guarapari", state: "ES", stateName: "Espírito Santo" },
  { id: "3204955", name: "Viana", state: "ES", stateName: "Espírito Santo" },
  
  // Paraíba
  { id: "2507507", name: "João Pessoa", state: "PB", stateName: "Paraíba" },
  { id: "2504009", name: "Campina Grande", state: "PB", stateName: "Paraíba" },
  { id: "2513703", name: "Santa Rita", state: "PB", stateName: "Paraíba" },
  { id: "2512507", name: "Patos", state: "PB", stateName: "Paraíba" },
  { id: "2500700", name: "Bayeux", state: "PB", stateName: "Paraíba" },
  { id: "2515302", name: "Sousa", state: "PB", stateName: "Paraíba" },
  { id: "2505501", name: "Cajazeiras", state: "PB", stateName: "Paraíba" },
  { id: "2502706", name: "Cabedelo", state: "PB", stateName: "Paraíba" },
  { id: "2511400", name: "Monteiro", state: "PB", stateName: "Paraíba" },
  { id: "2514503", name: "São Bento", state: "PB", stateName: "Paraíba" },
  
  // Amazonas
  { id: "1302603", name: "Manaus", state: "AM", stateName: "Amazonas" },
  { id: "1301407", name: "Itacoatiara", state: "AM", stateName: "Amazonas" },
  { id: "1303403", name: "Parintins", state: "AM", stateName: "Amazonas" },
  { id: "1302702", name: "Manacapuru", state: "AM", stateName: "Amazonas" },
  { id: "1300607", name: "Coari", state: "AM", stateName: "Amazonas" },
  { id: "1304062", name: "Tefé", state: "AM", stateName: "Amazonas" },
  { id: "1301803", name: "Tabatinga", state: "AM", stateName: "Amazonas" },
  { id: "1301852", name: "Maués", state: "AM", stateName: "Amazonas" },
  { id: "1300300", name: "Carauari", state: "AM", stateName: "Amazonas" },
  { id: "1301001", name: "Humaitá", state: "AM", stateName: "Amazonas" },
  
  // Mato Grosso
  { id: "5103403", name: "Cuiabá", state: "MT", stateName: "Mato Grosso" },
  { id: "5107909", name: "Várzea Grande", state: "MT", stateName: "Mato Grosso" },
  { id: "5105606", name: "Rondonópolis", state: "MT", stateName: "Mato Grosso" },
  { id: "5106505", name: "Sinop", state: "MT", stateName: "Mato Grosso" },
  { id: "5107040", name: "Tangará da Serra", state: "MT", stateName: "Mato Grosso" },
  { id: "5101001", name: "Cáceres", state: "MT", stateName: "Mato Grosso" },
  { id: "5106752", name: "Sorriso", state: "MT", stateName: "Mato Grosso" },
  { id: "5103205", name: "Barra do Garças", state: "MT", stateName: "Mato Grosso" },
  { id: "5104104", name: "Lucas do Rio Verde", state: "MT", stateName: "Mato Grosso" },
  { id: "5103809", name: "Primavera do Leste", state: "MT", stateName: "Mato Grosso" },
  
  // Rio Grande do Norte
  { id: "2408102", name: "Natal", state: "RN", stateName: "Rio Grande do Norte" },
  { id: "2403251", name: "Mossoró", state: "RN", stateName: "Rio Grande do Norte" },
  { id: "2403103", name: "Parnamirim", state: "RN", stateName: "Rio Grande do Norte" },
  { id: "2408003", name: "São Gonçalo do Amarante", state: "RN", stateName: "Rio Grande do Norte" },
  { id: "2305001", name: "Macaíba", state: "RN", stateName: "Rio Grande do Norte" },
  { id: "2401453", name: "Ceará-Mirim", state: "RN", stateName: "Rio Grande do Norte" },
  { id: "2401107", name: "Caicó", state: "RN", stateName: "Rio Grande do Norte" },
  { id: "2400505", name: "Assu", state: "RN", stateName: "Rio Grande do Norte" },
  { id: "2402600", name: "Currais Novos", state: "RN", stateName: "Rio Grande do Norte" },
  { id: "2406502", name: "Nova Cruz", state: "RN", stateName: "Rio Grande do Norte" },
  
  // Mato Grosso do Sul
  { id: "5002704", name: "Campo Grande", state: "MS", stateName: "Mato Grosso do Sul" },
  { id: "5004106", name: "Dourados", state: "MS", stateName: "Mato Grosso do Sul" },
  { id: "5007307", name: "Três Lagoas", state: "MS", stateName: "Mato Grosso do Sul" },
  { id: "5001904", name: "Corumbá", state: "MS", stateName: "Mato Grosso do Sul" },
  { id: "5006200", name: "Ponta Porã", state: "MS", stateName: "Mato Grosso do Sul" },
  { id: "5004304", name: "Sidrolândia", state: "MS", stateName: "Mato Grosso do Sul" },
  { id: "5004908", name: "Naviraí", state: "MS", stateName: "Mato Grosso do Sul" },
  { id: "5000203", name: "Aquidauana", state: "MS", stateName: "Mato Grosso do Sul" },
  { id: "5005400", name: "Nova Andradina", state: "MS", stateName: "Mato Grosso do Sul" },
  { id: "5002001", name: "Coxim", state: "MS", stateName: "Mato Grosso do Sul" },
  
  // Alagoas
  { id: "2704302", name: "Maceió", state: "AL", stateName: "Alagoas" },
  { id: "2700102", name: "Arapiraca", state: "AL", stateName: "Alagoas" },
  { id: "2706703", name: "Rio Largo", state: "AL", stateName: "Alagoas" },
  { id: "2707909", name: "União dos Palmares", state: "AL", stateName: "Alagoas" },
  { id: "2706307", name: "Penedo", state: "AL", stateName: "Alagoas" },
  { id: "2705002", name: "Palmeira dos Índios", state: "AL", stateName: "Alagoas" },
  { id: "2707701", name: "São Miguel dos Campos", state: "AL", stateName: "Alagoas" },
  { id: "2707305", name: "Santana do Ipanema", state: "AL", stateName: "Alagoas" },
  { id: "2701605", name: "Coruripe", state: "AL", stateName: "Alagoas" },
  { id: "2703908", name: "Marechal Deodoro", state: "AL", stateName: "Alagoas" },
  
  // Piauí
  { id: "2211001", name: "Teresina", state: "PI", stateName: "Piauí" },
  { id: "2208502", name: "Parnaíba", state: "PI", stateName: "Piauí" },
  { id: "2207702", name: "Picos", state: "PI", stateName: "Piauí" },
  { id: "2205003", name: "Floriano", state: "PI", stateName: "Piauí" },
  { id: "2207934", name: "Piripiri", state: "PI", stateName: "Piauí" },
  { id: "2200509", name: "Altos", state: "PI", stateName: "Piauí" },
  { id: "2202406", name: "Campo Maior", state: "PI", stateName: "Piauí" },
  { id: "2200905", name: "Barras", state: "PI", stateName: "Piauí" },
  { id: "2211308", name: "União", state: "PI", stateName: "Piauí" },
  { id: "2201903", name: "Bom Jesus", state: "PI", stateName: "Piauí" },
  
  // Sergipe
  { id: "2800308", name: "Aracaju", state: "SE", stateName: "Sergipe" },
  { id: "2805703", name: "Nossa Senhora do Socorro", state: "SE", stateName: "Sergipe" },
  { id: "2803302", name: "Lagarto", state: "SE", stateName: "Sergipe" },
  { id: "2801306", name: "Itabaiana", state: "SE", stateName: "Sergipe" },
  { id: "2806701", name: "São Cristóvão", state: "SE", stateName: "Sergipe" },
  { id: "2804003", name: "Estância", state: "SE", stateName: "Sergipe" },
  { id: "2807105", name: "Simão Dias", state: "SE", stateName: "Sergipe" },
  { id: "2805000", name: "Tobias Barreto", state: "SE", stateName: "Sergipe" },
  { id: "2802106", name: "Propriá", state: "SE", stateName: "Sergipe" },
  { id: "2800670", name: "Barra dos Coqueiros", state: "SE", stateName: "Sergipe" },
  
  // Rondônia
  { id: "1100205", name: "Porto Velho", state: "RO", stateName: "Rondônia" },
  { id: "1100114", name: "Ji-Paraná", state: "RO", stateName: "Rondônia" },
  { id: "1100023", name: "Ariquemes", state: "RO", stateName: "Rondônia" },
  { id: "1100288", name: "Vilhena", state: "RO", stateName: "Rondônia" },
  { id: "1100155", name: "Cacoal", state: "RO", stateName: "Rondônia" },
  { id: "1101468", name: "Jaru", state: "RO", stateName: "Rondônia" },
  { id: "1100452", name: "Rolim de Moura", state: "RO", stateName: "Rondônia" },
  { id: "1100346", name: "Pimenta Bueno", state: "RO", stateName: "Rondônia" },
  { id: "1100098", name: "Guajará-Mirim", state: "RO", stateName: "Rondônia" },
  { id: "1100304", name: "Ouro Preto do Oeste", state: "RO", stateName: "Rondônia" },
  
  // Tocantins
  { id: "1721000", name: "Palmas", state: "TO", stateName: "Tocantins" },
  { id: "1702109", name: "Araguaína", state: "TO", stateName: "Tocantins" },
  { id: "1713205", name: "Gurupi", state: "TO", stateName: "Tocantins" },
  { id: "1720101", name: "Porto Nacional", state: "TO", stateName: "Tocantins" },
  { id: "1718550", name: "Paraíso do Tocantins", state: "TO", stateName: "Tocantins" },
  { id: "1705102", name: "Colinas do Tocantins", state: "TO", stateName: "Tocantins" },
  { id: "1707702", name: "Guaraí", state: "TO", stateName: "Tocantins" },
  { id: "1701903", name: "Araguatins", state: "TO", stateName: "Tocantins" },
  { id: "1718204", name: "Miracema do Tocantins", state: "TO", stateName: "Tocantins" },
  { id: "1704105", name: "Augustinópolis", state: "TO", stateName: "Tocantins" },
  
  // Acre
  { id: "1200401", name: "Rio Branco", state: "AC", stateName: "Acre" },
  { id: "1200104", name: "Cruzeiro do Sul", state: "AC", stateName: "Acre" },
  { id: "1200500", name: "Sena Madureira", state: "AC", stateName: "Acre" },
  { id: "1200807", name: "Tarauacá", state: "AC", stateName: "Acre" },
  { id: "1200203", name: "Feijó", state: "AC", stateName: "Acre" },
  { id: "1200013", name: "Brasiléia", state: "AC", stateName: "Acre" },
  { id: "1200302", name: "Plácido de Castro", state: "AC", stateName: "Acre" },
  { id: "1200708", name: "Senador Guiomard", state: "AC", stateName: "Acre" },
  { id: "1200609", name: "Epitaciolândia", state: "AC", stateName: "Acre" },
  { id: "1200906", name: "Xapuri", state: "AC", stateName: "Acre" },
  
  // Amapá
  { id: "1600303", name: "Macapá", state: "AP", stateName: "Amapá" },
  { id: "1600501", name: "Santana", state: "AP", stateName: "Amapá" },
  { id: "1600204", name: "Laranjal do Jari", state: "AP", stateName: "Amapá" },
  { id: "1600402", name: "Oiapoque", state: "AP", stateName: "Amapá" },
  { id: "1600600", name: "Mazagão", state: "AP", stateName: "Amapá" },
  { id: "1600154", name: "Porto Grande", state: "AP", stateName: "Amapá" },
  { id: "1600055", name: "Tartarugalzinho", state: "AP", stateName: "Amapá" },
  { id: "1600709", name: "Vitória do Jari", state: "AP", stateName: "Amapá" },
  { id: "1600105", name: "Calçoene", state: "AP", stateName: "Amapá" },
  { id: "1600808", name: "Ferreira Gomes", state: "AP", stateName: "Amapá" },
  
  // Roraima
  { id: "1400100", name: "Boa Vista", state: "RR", stateName: "Roraima" },
  { id: "1400407", name: "Rorainópolis", state: "RR", stateName: "Roraima" },
  { id: "1400027", name: "Caracaraí", state: "RR", stateName: "Roraima" },
  { id: "1400308", name: "Mucajaí", state: "RR", stateName: "Roraima" },
  { id: "1400209", name: "Alto Alegre", state: "RR", stateName: "Roraima" },
  { id: "1400050", name: "Bonfim", state: "RR", stateName: "Roraima" },
  { id: "1400456", name: "Cantá", state: "RR", stateName: "Roraima" },
  { id: "1400506", name: "São João da Baliza", state: "RR", stateName: "Roraima" },
  { id: "1400605", name: "São Luiz", state: "RR", stateName: "Roraima" },
  { id: "1400159", name: "Pacaraima", state: "RR", stateName: "Roraima" },
  
  // Distrito Federal
  { id: "5300108", name: "Brasília", state: "DF", stateName: "Distrito Federal" },
]

export function searchCities(query: string): IBGECity[] {
  if (!query || query.length < 2) return []
  
  const normalizedQuery = query.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
  
  return BRAZILIAN_CITIES.filter(city => {
    const normalizedName = city.name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    const normalizedState = city.state.toLowerCase()
    const normalizedStateName = city.stateName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    
    return normalizedName.includes(normalizedQuery) || 
           normalizedState.includes(normalizedQuery) ||
           normalizedStateName.includes(normalizedQuery)
  }).slice(0, 10)
}

export function getCityById(ibgeCode: string): IBGECity | undefined {
  return BRAZILIAN_CITIES.find(city => city.id === ibgeCode)
}

export function getCitiesByState(stateCode: string): IBGECity[] {
  return BRAZILIAN_CITIES.filter(city => city.state === stateCode)
}

export const BRAZILIAN_STATES = [
  { code: "AC", name: "Acre" },
  { code: "AL", name: "Alagoas" },
  { code: "AP", name: "Amapá" },
  { code: "AM", name: "Amazonas" },
  { code: "BA", name: "Bahia" },
  { code: "CE", name: "Ceará" },
  { code: "DF", name: "Distrito Federal" },
  { code: "ES", name: "Espírito Santo" },
  { code: "GO", name: "Goiás" },
  { code: "MA", name: "Maranhão" },
  { code: "MT", name: "Mato Grosso" },
  { code: "MS", name: "Mato Grosso do Sul" },
  { code: "MG", name: "Minas Gerais" },
  { code: "PA", name: "Pará" },
  { code: "PB", name: "Paraíba" },
  { code: "PR", name: "Paraná" },
  { code: "PE", name: "Pernambuco" },
  { code: "PI", name: "Piauí" },
  { code: "RJ", name: "Rio de Janeiro" },
  { code: "RN", name: "Rio Grande do Norte" },
  { code: "RS", name: "Rio Grande do Sul" },
  { code: "RO", name: "Rondônia" },
  { code: "RR", name: "Roraima" },
  { code: "SC", name: "Santa Catarina" },
  { code: "SP", name: "São Paulo" },
  { code: "SE", name: "Sergipe" },
  { code: "TO", name: "Tocantins" }
]
